import { get_axios_instance, api_variables,get_axios_file_instance, errorHandler } from '@/apis/variables.js';

var axios_instance_upload_template = get_axios_file_instance(api_variables.SERVICE_FNF_UPLOAD_TEMPLATE);


const state = {
    data: {},
    isFetching: false,
    isSaving: false,
    isDeleting: false,
    editMode: false,
    record: []
};


const mutations = {
    set: (state, [payload, id]) => {
        state.data[id] = payload;
        state.data = {...state.data }
    },
}

const actions = {

    async uploadTemplate({ commit }, payload) {
        //console.log("[state/Organisation/Utilities/uploadTemplate] Calling API...", payload);
        try {
            // commit("setFetching", true);
            let res = await axios_instance_upload_template.post(``,{body:payload});
            // commit("setFetching", false);
            //console.log("[state/Organisation/Utilities/uploadTemplate] res:", res);
            return res;
        } catch (err) {
            //console.log(err);
            throw errorHandler(err.response);
        }
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    // getters
};